/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ProvisionApplePayRequest} from '@cash-web/protos/squareup/franklin/app/apple_pay.pb'
import {ProvisionApplePayResponse} from '@cash-web/protos/squareup/franklin/app/apple_pay.pb'


export const provisionApplePay = (request: ProvisionApplePayRequest, options?: CashRequestOptions) => post<ProvisionApplePayRequest, ProvisionApplePayResponse>("/2.0/cash/provision-apple-pay", request, {...options, rejectOnError: true })